import { Box } from "@chakra-ui/react";

import { Pagination } from "components/Pagination";
import { ActualAppointmentsMobileRows } from "./ActualAppointmentsMobileRows";

interface IProps {
  totalAppointments: number;
  limit: number;
}

const ActualAppointmentsMobile = ({ totalAppointments, limit }: IProps) => {
  return (
    <>
      <ActualAppointmentsMobileRows limit={limit} />
      <Box mt={4}>
        <Pagination total={totalAppointments} limit={limit} />
      </Box>
    </>
  );
};

export { ActualAppointmentsMobile };
